module.exports = __webpack_public_path__ + "static/media/loader-xs.55e01a71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader-xs.svg
// module id = 77
// module chunks = 0